export default __webpack_public_path__ + "static/page-header-dont-1-87374e8b983233e46f67792d657ba5e0.png";